export async function transferToSpotifyWithProgress(playlists, setProgress) {
  const getAccessToken = () => localStorage.getItem("accessToken");
  const accessToken = getAccessToken();
  if (!accessToken) throw new Error("Spotify token missing");

  let total = playlists.reduce((sum, pl) => sum + (pl.tracks?.length || 0), 0);
  let current = 0, success = 0, failed = 0, errors = [];

  for (const playlist of playlists) {
    // 1. Check for existing playlist with same name
    let playlistsRes = await fetch(
      "https://api.spotify.com/v1/me/playlists?limit=50",
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    let playlistsData = await playlistsRes.json();
    let existingPlaylist = playlistsData.items.find(
      (pl) => pl.name === playlist.name
    );
    let newPlaylistId = null;
    if (existingPlaylist) {
      newPlaylistId = existingPlaylist.id;
      // Remove all tracks from the playlist
      let next = true, offset = 0;
      while (next) {
        const tracksRes = await fetch(
          `https://api.spotify.com/v1/playlists/${newPlaylistId}/tracks?fields=items(track(uri)),next&limit=100&offset=${offset}`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
        const tracksData = await tracksRes.json();
        const uris = (tracksData.items || []).map(item => item.track?.uri).filter(Boolean);
        if (uris.length > 0) {
          await fetch(
            `https://api.spotify.com/v1/playlists/${newPlaylistId}/tracks`,
            {
              method: "DELETE",
              headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ tracks: uris.map(uri => ({ uri })) }),
            }
          );
        }
        if (!tracksData.next) next = false;
        else offset += 100;
      }
    } else {
      // Create playlist on Spotify
      try {
        const createdRes = await fetch("https://api.spotify.com/v1/me/playlists", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: playlist.name,
            description: playlist.description || "",
            public: playlist.public,
          }),
        });
        const createdData = await createdRes.json();
        if (!createdRes.ok || !createdData.id) {
          errors.push({ playlist, error: createdData });
          continue;
        }
        newPlaylistId = createdData.id;
      } catch (err) {
        errors.push({ playlist, error: err });
        continue;
      }
    }

    // 2. Search and add tracks
    const trackUris = [];
    for (const track of playlist.tracks || []) {
      setProgress(prev => ({
        ...prev,
        current: current + 1,
        currentTrack: track,
        success,
        failed,
      }));

      try {
        const query = encodeURIComponent(`${track.title} ${track.artist || ""}`);
        const searchRes = await fetch(
          `https://api.spotify.com/v1/search?q=${query}&type=track&limit=1`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );
        const searchData = await searchRes.json();
        const match = searchData?.tracks?.items?.[0];
        if (match?.uri) {
          trackUris.push(match.uri);
          success++;
        } else {
          failed++;
          errors.push({ track, error: "No match found" });
        }
        await delay(100); // avoid rate limiting
      } catch (err) {
        failed++;
        errors.push({ track, error: err });
      }
      current++;
    }

    // 3. Add tracks in batches of 100
    for (let i = 0; i < trackUris.length; i += 100) {
      const chunk = trackUris.slice(i, i + 100);
      await fetch(`https://api.spotify.com/v1/playlists/${newPlaylistId}/tracks`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ uris: chunk }),
      });
    }
  }

  setProgress(prev => ({
    ...prev,
    current,
    success,
    failed,
    status: "done",
    errors,
  }));
}

function delay(ms) {
  return new Promise((res) => setTimeout(res, ms));
} 